var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckedCart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.864,
    height: 16,
    viewBox: "0 0 18.864 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4097",
    "data-name": "Group 4097",
    transform: "translate(-771.326 -866.283)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-shopping-cart",
    "data-name": "Icon feather-shopping-cart",
    transform: "translate(772.326 867.283)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_805",
    "data-name": "Path 805",
    d: "M13.88,30.94a.94.94,0,1,1-.94-.94A.94.94,0,0,1,13.88,30.94Z",
    transform: "translate(-7.525 -17.88)",
    fill: "none",
    stroke: "#2e6775",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_806",
    "data-name": "Path 806",
    d: "M30.38,30.94a.94.94,0,1,1-.94-.94A.94.94,0,0,1,30.38,30.94Z",
    transform: "translate(-15.593 -17.88)",
    fill: "none",
    stroke: "#2e6775",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_807",
    "data-name": "Path 807",
    d: "M-.5,1.5H2.167L3.953,8.964a1.3,1.3,0,0,0,1.333.9h8.48a1.3,1.3,0,0,0,1.333-.9l1.067-4.677",
    transform: "translate(0.5 -1.5)",
    fill: "none",
    stroke: "#2e6775",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M2.836,10.682.122,7.968a.418.418,0,0,1,0-.591l.59-.591a.418.418,0,0,1,.591,0L3.132,8.616,7.048,4.7a.418.418,0,0,1,.591,0l.59.591a.418.418,0,0,1,0,.591l-4.8,4.8A.418.418,0,0,1,2.836,10.682Z",
    transform: "translate(778.824 861.732)",
    fill: "#0d6877"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedCart);
export default __webpack_public_path__ + "static/media/checkedCart.5ef3c6cf.svg";
export { ForwardRef as ReactComponent };